import { createFileRoute } from "@tanstack/react-router";
import { ChatGuidePage } from "@/modules/nutrition/presentation/pages/ChatGuidePage";

export const Route = createFileRoute("/_authenticated/nutrition-guide")({
  component: ChatGuidePage,
});
